import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { Config, provideDefaultConfig } from '@spartacus/core';
import { OrderEntriesSource } from '@spartacus/cart/base/root';
import '@spartacus/storefront';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ImportExportConfig {
  static {
    this.ɵfac = function ImportExportConfig_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImportExportConfig)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ImportExportConfig,
      factory: function ImportExportConfig_Factory(__ngFactoryType__) {
        let __ngConditionalFactory__ = null;
        if (__ngFactoryType__) {
          __ngConditionalFactory__ = new (__ngFactoryType__ || ImportExportConfig)();
        } else {
          __ngConditionalFactory__ = i0.ɵɵinject(Config);
        }
        return __ngConditionalFactory__;
      },
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImportExportConfig, [{
    type: Injectable,
    args: [{
      providedIn: 'root',
      useExisting: Config
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Indicates from which source the new saved cart name
 * should be taken.
 */
var CartNameSource;
(function (CartNameSource) {
  CartNameSource["FILE_NAME"] = "fileName";
  CartNameSource["DATE_TIME"] = "dateTime";
})(CartNameSource || (CartNameSource = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultImportExportConfig = {
  cartImportExport: {
    file: {
      separator: ','
    },
    import: {
      fileValidity: {
        maxSize: 1,
        maxEntries: {
          [OrderEntriesSource.NEW_SAVED_CART]: 100,
          [OrderEntriesSource.SAVED_CART]: 100,
          [OrderEntriesSource.ACTIVE_CART]: 10,
          [OrderEntriesSource.QUICK_ORDER]: 10
        },
        allowedTypes: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'text/csv', '.csv']
      },
      cartNameGeneration: {
        source: CartNameSource.FILE_NAME
      }
    },
    export: {
      additionalColumns: [{
        name: {
          key: 'name'
        },
        value: 'product.name'
      }, {
        name: {
          key: 'price'
        },
        value: 'totalPrice.formattedValue'
      }],
      messageEnabled: true,
      downloadDelay: 1000,
      maxEntries: 1000,
      fileOptions: {
        fileName: 'cart',
        extension: 'csv',
        type: 'text/csv'
      }
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ImportExportCoreModule {
  static forRoot() {
    return {
      ngModule: ImportExportCoreModule,
      providers: [provideDefaultConfig(defaultImportExportConfig)]
    };
  }
  static {
    this.ɵfac = function ImportExportCoreModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImportExportCoreModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ImportExportCoreModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImportExportCoreModule, [{
    type: NgModule,
    args: [{}]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CartNameSource, ImportExportConfig, ImportExportCoreModule, defaultImportExportConfig };
